<template>
    <div class="root-node-container" :data-exec-mode="execMode">
        <!-- Modo visualização -->
        <template v-if="execMode == gConsts.rt.execModes.VIEW">
            <div class="root-node-header">
                <span class="root-node-number">{{ orderNumber }}</span>
                <span class="root-node-title">{{ node.report.text || node.layout.caption }}</span>
            </div>
            <div class="root-node-content">
                <template v-if="id == 'step_denticao'">
                    <p class="root-node-content-text" v-if="selectedDenticaoReportNode">{{ selectedDenticaoReportNode.reportText }}</p>
                </template>

                <section class="root-node-children" v-show="filteredChildren.layer.length > 0">
                    <layerNodeSearch v-for="child in filteredChildren.layer" 
                        :key="child.id" :node="child" :execMode="execMode" 
                        :activeNode="activeNode ? activeNode.layer == child.id ? activeNode : null : null" 
                        :id="child.id">
                    </layerNodeSearch>
                </section>

                <section class="root-node-children" v-show="filteredChildren.label.length > 0">
                    <labelNodeSearch v-for="(child, index) in filteredChildren.label" 
                    :key="child.id" :node="child" :reportNode="labelChildrenReportNodes[index]" :execMode="execMode"
                    :active="activeNode ? activeNode.label == child.id : false" :id="child.id"></labelNodeSearch>
                </section>
            </div>
        </template>

        <!-- Modo de edição (WORK) -->
        <template v-if="execMode == gConsts.rt.execModes.WORK">
            <expansionPanelUI @onExpandedChange="toggleActive" :expanded="isExpansionPanelExpanded" class="root-node-expansion-panel">
                <template #header>
                    <div class="root-node-header">
                        <span class="root-node-number">{{ orderNumber }}</span>
                        <span class="root-node-title">{{ node.layout.caption }}</span>
                    </div>
                </template>
                <template #content>
                    <template v-if="id == 'step_denticao' && !searchMode">
                        <!-- Tipo de dentição -->
                        <!-- <section class="denticao-section">
                            <label for="denticao-select" class="denticao-section-label">Dentição:</label>
                            <selectUI 
                                id="denticao-select"
                                :options="getDenticaoSelectItems" 
                                :defaultSelected="selectedDenticao"
                                @change="onTipoDenticaoChange"
                            />
                        </section> -->

                        <!-- <odontogramaCMP :node="node" :id="id"></odontogramaCMP> -->
                    </template>

                    <section class="root-node-children" v-show="filteredChildren.layer.length > 0">
                        <layerNodeSearch v-for="child in filteredChildren.layer" :searchValue="searchValue" :key="child.id" :node="child" :execMode="execMode"
                        :activeNode="activeNode ? activeNode.layer == child.id ? activeNode : null : null" :id="child.id" :searchMode="searchMode"></layerNodeSearch>
                    </section>

                    <section class="root-node-children" v-show="filteredChildren.label.length > 0">
                        <labelNodeSearch v-for="(child, index) in filteredChildren.label" :searchValue="searchValue"
                        :key="child.id" :node="child" :reportNode="labelChildrenReportNodes[index]" :execMode="execMode"
                        :active="activeNode ? activeNode.label == child.id : false" :id="child.id" :searchMode="searchMode"></labelNodeSearch>
                    </section>
                </template>
            </expansionPanelUI>
        </template>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import expansionPanelUI from '@/components/ui/expansionPanel.vue';
import selectUI from '@/components/ui/select/select.vue';
import odontogramaCMP from '../relatorioDinamico/nodes/odontograma.vue';
import layerNodeSearch from './layerNodeSearch.vue';
import labelNodeSearch from './labelNodeSearch.vue';

import { gConsts } from '@/globals/gConsts';
import { reportUtils } from '@/features/report/lib/reportUtils';
import { evtBus } from '@/main';
import _ from 'lodash';

export default {
    name: 'rootNodeSearch',
    components: {
        expansionPanelUI,
        // selectUI,
        // odontogramaCMP,
        layerNodeSearch,
        labelNodeSearch
    },
    props: {
        execMode: {
            type: String,
            default: gConsts.rt.execModes.WORK
        },
        node: {
            type: Object,
            required: true
        },
        id: {
            type: String,
            required: true
        },
        orderNumber: {
            type: Number,
            required: true
        },
        activeNode: {
            type: Object,
            default: null
        },
        searchMode: {
            type: Boolean,
            default: false
        },
        searchValue: {
            type: String,
            default: ''
        }
    },

    data() {
        return {
            gConsts: gConsts,
            isActive: this.activeNode != null,
            selectedDenticao: null,
            filteredChildren: {
                layer: [],
                label: []
            }
        }
    },

    methods: {

        toggleActive() {
            this.isActive = !this.isActive;

            evtBus.$emit('evt_relatorioDinamico_activateNode', { nodeId: this.id, nodeType: gConsts.node.layout.types.STEP });
        },

        onTipoDenticaoChange(selectedValue) {
            this.selectedDenticao = selectedValue;
            this.$store.dispatch('ACT_reportNodes_setDenticaoNode', {
                nodeId: this.selectedDenticao
            });
        },

        updateFilteredLayerChildren(searchValue) {
            if (!searchValue.trim()) {
                this.filteredChildren.layer = this.layerChildren;
                return
            }
            this.filteredChildren.layer = this.layerChildren.filter(layerNode => {
                const labelNodes = this.GET_filteredNodes.filter(node => node.layout.parent === layerNode.id);
                return labelNodes.some(labelNode => {
                    return reportUtils.labelSearchForReportMatches(labelNode, searchValue);
                });
            });

        },

        updateFilteredLabelChildren(searchValue) {
            if (!searchValue.trim()) {
                this.filteredChildren.label = this.labelChildren;
                return
            }
            this.filteredChildren.label = this.labelChildren.filter(labelNode => {
                return reportUtils.labelSearchForReportMatches(labelNode, searchValue);
            });
        },
    },

    watch: {
        activeNode(newVal) {
            this.isActive = newVal != null;
        },
        GET_selectedDenticaoReportNode: {
            handler(newVal) {
                if (this.id == 'step_denticao') {
                    this.selectedDenticao = newVal?.id ?? null;
                }
            },
            deep: true
        },
        searchValue: {
            handler(newVal) {
                if (this.$updateFilteredLayerChildren)
                    this.$updateFilteredLayerChildren(newVal);
                if (this.$updateFilteredLabelChildren)
                    this.$updateFilteredLabelChildren(newVal);
            },
            immediate: true
        }
    },

    computed: {
        ...mapGetters([
            'GET_filteredNodes',
            'GET_reportNodes',
            'GET_selectedDenticaoReportNode'
        ]),

        isExpansionPanelExpanded() {
            return this.isActive || this.searchValue.trim().length > 0;
        },
        
        selectedDenticaoReportNode() {
            return this.GET_reportNodes.find(reportNode => reportNode.id == this.selectedDenticao);
        },

        getDenticaoSelectItems() {
            const tipoDenticaoNodes = this.GET_filteredNodes.filter(node => (node.layout.parent === 'layer_tipoDenticao'));
            return [
                { value: null, label: '[Indefinida]' },
                ...tipoDenticaoNodes.map(node => ({ value: node.id, label: node.layout.label }))
            ];
        },

        layerChildren() { 
            return this.GET_filteredNodes.filter(node => 
                (node.layout.parent === this.node.id) && node.layout.group == gConsts.node.layout.groups.FOLDER
            );
        },

        labelChildren() {
            if (this.id == 'step_livre') {
                return this.GET_filteredNodes.filter(node => (node.layout.parent === 'layer_anotsLivres'))
            }
            return [];
        },

        labelChildrenReportNodes() {
            return this.filteredChildren.label.map(child => this.GET_reportNodes.find(reportNode => reportNode.id === child.id));
        }
    },

    mounted() {
        this.$updateFilteredLayerChildren = _.debounce(this.updateFilteredLayerChildren, 150);
        this.$updateFilteredLabelChildren = _.debounce(this.updateFilteredLabelChildren, 150);

        this.updateFilteredLayerChildren(this.searchValue);
        this.updateFilteredLabelChildren(this.searchValue);
    }
}
</script>

<style scoped>

/* Modo visualização */

.root-node-container[data-exec-mode="view"] .root-node-header {
    gap: var(--spacing-sm);
}

.root-node-container[data-exec-mode="view"] .root-node-number {
    padding: 0;
    font-size: var(--text-md);
    font-weight: 700;
    color: var(--color-secondary);
    background-color: transparent;
}

.root-node-container[data-exec-mode="view"] .root-node-title {
    font-size: var(--text-md);
    font-weight: 700;
}

.root-node-container[data-exec-mode="view"] .root-node-content {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-sm);
    padding: var(--spacing-sm) var(--spacing);
}

.root-node-container[data-exec-mode="view"] .root-node-content-text {
    padding: 0;
    margin: 0;
    font-family: var(--font-family-primary);
    font-size: var(--text-sm);
    font-weight: 400;
    color: var(--color-secondary);
    text-align: left;
}

.root-node-container[data-exec-mode="view"] .root-node-children {
    gap: 0;
}


/* Modo de edição (WORK) */

.root-node-expansion-panel > :deep(.expansion-panel-content) {
    border-top: 1px solid var(--border-primary);
}

.root-node-header {
    display: flex;
    align-items: center;
    gap: var(--spacing);
    width: 100%;
}

.expansion-panel-header[data-expanded="true"] .root-node-number {
    color: var(--color-white);
    background-color: var(--color-primary);
}
.expansion-panel-header[data-expanded="true"] .root-node-title {
    font-weight: 700;
    color: var(--color-primary);
}

.root-node-number {
    font-family: var(--font-family-primary);
    font-size: var(--text-xs);
    font-weight: 500;
    padding: var(--spacing-sm) var(--spacing);
    color: var(--color-dark-gray);
    background-color: var(--background-gray);
    border-radius: var(--radius-md);
    transition: all 0.2s ease-in-out;
}

.root-node-title {
    font-family: var(--font-family-primary);
    font-weight: 600;
    font-size: var(--text-md);
    color: var(--color-secondary);
}

.root-node-children {
    display: flex;
    flex-direction: column;
}

.denticao-section {
    display: flex;
    align-items: center;
    gap: var(--spacing);
    padding: 0 var(--spacing-sm);
    margin-bottom: var(--spacing-lg);
}


.denticao-section-label {
    font-family: var(--font-family-primary);
    font-size: var(--text-md);
    font-weight: 500;
    color: var(--color-secondary);
    margin-top: -3px;
}
</style>